document.addEventListener('DOMContentLoaded', () => {
    const addShowMoreButtonListeners = () => {
        const sections = document.querySelectorAll('.section-gallery-two');

        if (sections) {
            sections.forEach((section, index) => {
                const button = section.querySelector('.gallery-show-more');
                if (button) {
                    button.setAttribute('data-index', index + 1);
                }
            })

            sections.forEach((section) => {
                const button = section.querySelector('.gallery-show-more');
                console
                if (button) {
                    button.addEventListener('click', async (event) => {
                        const button = event.target;
                        button.classList.add('btn-loading');

                        const postId = button.getAttribute('data-post-id');
                        const number = parseInt(button.getAttribute('data-number'));
                        const offset = parseInt(button.getAttribute('data-offset'));
                        const index = button.getAttribute('data-index');

                        const options = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'Cache-Control': 'no-cache',
                            },
                            mode: 'no-cors',
                        };

                        const form = new FormData();
                        form.append('action', 'load_more_gallery_two');
                        form.append('post_id', postId);
                        form.append('number', number);
                        form.append('offset', offset);
                        form.append('index', index);

                        const params = new URLSearchParams(form);
                        options.body = params;

                        try {
                            let response = await fetch('/wp-admin/admin-ajax.php', options);
                            let html = await response.text();
                            if (html) {
                                const galleryList = section.querySelector('.section-gallery-two__block');
                                if (galleryList) {
                                    galleryList.innerHTML = html;
                                    button.classList.remove('btn-loading');
                                    addShowMoreButtonListeners();
                                }
                            }
                        } catch (error) {
                            console.error('Ошибка при загрузке галереи:', error);
                        }
                    });
                }
            });
        }
    };

    addShowMoreButtonListeners();
});